import { HttpClient, HttpContext, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { patientBackendEndPointToken } from '../app.config';
import { DisableCache, LoadingUIEnabled } from '../loading.interceptor';
import {
  EnsureThreadRequest,
  EnsureThreadResponse,
  MarkThreadReadRequest,
  MarkThreadReadResponse,
  NotifyThreadMessageRequest,
  NotifyThreadMessageResponse,
  ThreadListFilters,
  ThreadListResponse
} from './messaging.models';

@Injectable({ providedIn: 'root' })
export class MessagingThreadsService {
  private readonly http = inject(HttpClient);
  private readonly backendApi = inject(patientBackendEndPointToken);
  private readonly apiBase = `${this.backendApi.replace(/\/fhir\/?$/, '')}`;

  ensureThread(payload: EnsureThreadRequest): Observable<EnsureThreadResponse> {
    return this.http.post<EnsureThreadResponse>(`${this.apiBase}/threads/ensure`, payload, {
      context: new HttpContext().set(DisableCache, true).set(LoadingUIEnabled, false)
    });
  }

  notifyThreadMessage(threadId: string, payload: NotifyThreadMessageRequest): Observable<NotifyThreadMessageResponse> {
    return this.http.post<NotifyThreadMessageResponse>(`${this.apiBase}/threads/${threadId}/messages/notify`, payload, {
      context: new HttpContext().set(DisableCache, true).set(LoadingUIEnabled, false)
    });
  }

  markThreadRead(threadId: string, payload: MarkThreadReadRequest): Observable<MarkThreadReadResponse> {
    return this.http.post<MarkThreadReadResponse>(`${this.apiBase}/threads/${threadId}/read`, payload, {
      context: new HttpContext().set(DisableCache, true).set(LoadingUIEnabled, false)
    });
  }

  listThreads(participantId: string, filters: ThreadListFilters): Observable<ThreadListResponse> {
    let params = new HttpParams().set('organizationId', filters.organizationId);

    if (filters.threadType) params = params.set('threadType', filters.threadType);
    if (typeof filters.archived === 'boolean') params = params.set('archived', String(filters.archived));
    if (typeof filters.unreadOnly === 'boolean') params = params.set('unreadOnly', String(filters.unreadOnly));

    return this.http.get<ThreadListResponse>(`${this.apiBase}/users/${participantId}/threads`, {
      params,
      context: new HttpContext().set(DisableCache, true).set(LoadingUIEnabled, false)
    });
  }
}
